// extracted by mini-css-extract-plugin
export default {"verification_container":"Verification_verification_container__b7Xg1"};